
import React, { useState } from 'react'

import { firestore } from '../../../../../firebase';
import TeamPlayersFB from '../TeamTemplates/TeamPlayersFB';

function AddPlayerTeam({teamId}) {

    const [playerId, setPlayerId] = useState("");
    const [playerImage, setPlayerImage] = useState("");
    const [playerName, setPlayerName] = useState("");

    const [error, setError] = useState("");

    const [show, setShow] = useState(false);

    function toggle() {
        if (!show) {
            setShow(true);
        } else {
            setShow(false);
        }
    }

    async function addPlayerHandler(e) {
        e.preventDefault();
        try {
            const teamPlayersRef = firestore.collection("team-players");

            if (!playerId || !playerImage || !playerName) {
                setError("Du må fylle ut alle feltene");
                return
            }

            const createdAt = new Date().toISOString()

            const data = {

                player_id: playerId,
                player_image: playerImage,
                player_name: playerName,
                team_id: teamId,
                createdAt

            }
            teamPlayersRef.add(data);
            setPlayerId("");
            setPlayerImage("");
            setPlayerName("");
        } catch (error) {
            setError(error)
        }
    }

    return (
        <div>
            <button className="btn btn-primary btn-rounded" onClick={toggle}>{show ? "Lukk" : "Legg til spiller"}</button>
            {show && (
                <React.Fragment>
                    <form onSubmit={addPlayerHandler}>

                        <label>Navn</label>
                        <input className="form-control mb-2" onChange={e => setPlayerName(e.target.value)} value={playerName} />

                        <label>Bilde</label>
                        <input className="form-control mb-2" placeholder="Bilde URL" value={playerImage} onChange={e => setPlayerImage(e.target.value)} />

                        <label>Spiller ID</label>
                        <input className="form-control mb-2" placeholder="Spiller ID" value={playerId} onChange={e => setPlayerId(e.target.value)} />
                        {error && <div className="alert alert-danger">Noe gikk galt {error}</div>}
                        <button className="btn btn-rounded btn-primary">Legg til spiller</button>

                    </form>
                    <TeamPlayersFB teamId={teamId} />
                </React.Fragment>
            )}

        </div>
    )

}
export default AddPlayerTeam